(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 96458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modal; }
});

// UNUSED EXPORTS: isEscEvent

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/components/ui/modal/styled.ts

var ModalOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ModalOverlay",
  componentId: "sc-1hc02xp-0"
})(["", ""], function (_ref) {
  var colors = _ref.theme.colors;
  return (0,styled_components_browser_esm/* css */.iv)(["position:fixed;overflow:auto;left:0;top:0;width:100%;height:100%;background-color:", ";display:flex;justify-content:center;z-index:20;"], colors.deepBlackOpacity);
});
var ModalWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ModalWrap",
  componentId: "sc-1hc02xp-1"
})(["", ""], function (_ref2) {
  var _ref2$theme = _ref2.theme,
      breakpoints = _ref2$theme.breakpoints,
      colors = _ref2$theme.colors,
      isBigHeightModal = _ref2.isBigHeightModal;
  return (0,styled_components_browser_esm/* css */.iv)(["position:relative;margin:auto;background:", ";border-radius:10px;max-width:1012px;max-height:", ";padding:32px;overflow-y:", ";overflow-x:auto;height:", ";@media (max-height:780px){height:", ";}@media (max-width:", "){padding:20px;max-width:calc(100% - 32px);}&::-webkit-scrollbar-track{border-radius:10px;background-color:", ";width:1160px;margin-left:64px;margin-right:64px;}&::-webkit-scrollbar{height:8px;background-color:white;width:8px;}&::-webkit-scrollbar-thumb{border-radius:10px;background-color:", ";}"], colors.white, !isBigHeightModal && 'min(calc(100% - 80px), 740px)', isBigHeightModal ? "hidden" : "initial", isBigHeightModal && "min-content", isBigHeightModal && "80%", breakpoints.maxMobileWidth, colors.bgGray, colors.black);
});
var IconCloseWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__IconCloseWrap",
  componentId: "sc-1hc02xp-2"
})(["position:absolute;margin:0;cursor:pointer;svg{width:20px;height:20px;fill:red;}"]);
var ButtonClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__ButtonClose",
  componentId: "sc-1hc02xp-3"
})(["", ""], function (_ref3) {
  var breakpoints = _ref3.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["position:absolute;display:flex;justify-content:center;align-items:center;width:20px;height:20px;top:23px;right:24px;border:none;background-color:transparent;@media (max-width:", "){top:23px;right:23px;}@media (max-width:", "){width:18px;height:18px;top:15px;right:15px;}"], breakpoints.maxTableWidth, breakpoints.maxMobileWidth);
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ui/modal/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var IconClose = function IconClose(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#a)",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "m1 1.506 18 17M19 1.506l-18 17"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          transform: "translate(0 .006)",
          d: "M0 0h20v20H0z"
        })
      })
    })]
  }));
};

IconClose.defaultProps = {
  width: "20",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};



var isEscEvent = function isEscEvent(evt) {
  return evt.key === "Escape" || evt.key === "Esc";
};

var Modal = function Modal(_ref) {
  var onClose = _ref.onClose,
      children = _ref.children,
      isBigHeightModal = _ref.isBigHeightModal;
  (0,react.useEffect)(function () {
    var handleEscKeyDown = function handleEscKeyDown(evt) {
      if (!isEscEvent(evt)) {
        return;
      }

      onClose();
    };

    document.addEventListener("keydown", handleEscKeyDown);
    return function () {
      document.removeEventListener("keydown", handleEscKeyDown);
    };
  }, [onClose]);
  (0,react.useEffect)(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "auto";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalOverlay, {
    onClick: onClose,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalWrap, {
      isBigHeightModal: isBigHeightModal,
      onClick: function onClick(evt) {
        return evt.stopPropagation();
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonClose, {
        onClick: onClose,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconCloseWrap, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconClose, {})
        })
      }), children]
    })
  });
};

/* harmony default export */ var modal = (Modal);

/***/ }),

/***/ 27802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/ui/modal/index.tsx + 1 modules
var modal = __webpack_require__(96458);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(76627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 3 modules
var es_button = __webpack_require__(72806);
// EXTERNAL MODULE: ./node_modules/react-code-input/dist/ReactCodeInput.js
var ReactCodeInput = __webpack_require__(38279);
var ReactCodeInput_default = /*#__PURE__*/__webpack_require__.n(ReactCodeInput);
;// CONCATENATED MODULE: ./src/views/authPage/components/authModal/styled.ts




var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Wrap",
  componentId: "sc-tlwls9-0"
})(["", ""], function (_ref) {
  var breakpoints = _ref.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["display:flex;flex-direction:column;gap:34px;@media (max-width:", "){max-width:280px;width:100%;gap:24px;}"], breakpoints.maxMobileWidth);
});
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "styled__Title",
  componentId: "sc-tlwls9-1"
})(["", ""], function (_ref2) {
  var breakpoints = _ref2.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["font-size:24px;font-weight:400;@media (max-width:", "){font-size:18px;}"], breakpoints.maxMobileWidth);
});
var ContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ContentWrap",
  componentId: "sc-tlwls9-2"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:16px;"]);
var Content = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__Content",
  componentId: "sc-tlwls9-3"
})(["font-size:14px;line-height:1.5;max-width:300px;"]);
var ChangePhoneButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__ChangePhoneButton",
  componentId: "sc-tlwls9-4"
})(["border:none;background-color:transparent;font-size:14px;text-decoration:underline;cursor:pointer;"]);
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "styled__Form",
  componentId: "sc-tlwls9-5"
})(["display:flex;flex-direction:column;gap:4px;width:100%;"]);
var InputLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "styled__InputLabel",
  componentId: "sc-tlwls9-6"
})(["font-size:13px;text-align:center;"]);
var InputTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__InputTitle",
  componentId: "sc-tlwls9-7"
})(["font-size:13px;text-align:center;"]);
var CodeInput = (0,styled_components_browser_esm/* default */.ZP)((react_input_mask_default())).withConfig({
  displayName: "styled__CodeInput",
  componentId: "sc-tlwls9-8"
})(["", ""], function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      breakpoints = _ref3$theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["border-radius:10.5px;border:1px solid ", ";display:flex;align-items:center;height:44px;width:100%;font-size:13px;padding:0 16px;align-self:center;margin:6px;@media (max-width:", "){margin-top:6px;}"], colors.lineGray, breakpoints.maxMobileWidth);
});
var GetNewCodeTimer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__GetNewCodeTimer",
  componentId: "sc-tlwls9-9"
})(["", ""], function (_ref4) {
  var colors = _ref4.theme.colors;
  return (0,styled_components_browser_esm/* css */.iv)(["font-size:12px;line-height:1.5;text-align:center;max-width:160px;align-self:center;color:", ";"], colors.darkGray);
});
var GetNewCode = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
  displayName: "styled__GetNewCode",
  componentId: "sc-tlwls9-10"
})(["", ""], function (_ref5) {
  var colors = _ref5.theme.colors;
  return (0,styled_components_browser_esm/* css */.iv)(["display:flex;align-items:center;align-self:center;justify-content:center;height:44px;border-radius:10.5px;background-color:", ";color:", ";text-transform:uppercase;font-size:13px;padding:0 40px;width:100%;cursor:pointer;&:hover,&:focus{background-color:", " !important;color:", " !important;border:none !important;}"], colors.black, colors.white, colors.black, colors.white);
});
var SubmitCode = (0,styled_components_browser_esm/* default */.ZP)(GetNewCode).withConfig({
  displayName: "styled__SubmitCode",
  componentId: "sc-tlwls9-11"
})(["margin-top:12px;"]);
var FormErrors = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__FormErrors",
  componentId: "sc-tlwls9-12"
})(["", ""], function (_ref6) {
  var colors = _ref6.theme.colors;
  return (0,styled_components_browser_esm/* css */.iv)(["font-size:11px;color:", ";text-align:center;"], colors.red);
});
var ConfirmInput = (0,styled_components_browser_esm/* default */.ZP)((ReactCodeInput_default())).withConfig({
  displayName: "styled__ConfirmInput",
  componentId: "sc-tlwls9-13"
})(["", ""], function (_ref7) {
  var _ref7$theme = _ref7.theme,
      unit = _ref7$theme.unit,
      colors = _ref7$theme.colors;
  return (0,styled_components_browser_esm/* css */.iv)(["width:max-content;color:", ";display:flex !important;gap:8px;flex-wrap:nowrap;margin:8px auto 0;"], colors.white);
});
// EXTERNAL MODULE: ./src/store/index.ts + 19 modules
var store = __webpack_require__(8918);
// EXTERNAL MODULE: ./src/store/core/slice.ts
var slice = __webpack_require__(6529);
// EXTERNAL MODULE: ./src/store/core/selectors.ts
var selectors = __webpack_require__(41393);
// EXTERNAL MODULE: ./libs/remote.ts
var remote = __webpack_require__(91840);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/authPage/components/authModal/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var schema = es/* object */.Ry({
  phone: es/* string */.Z_().required().max(4)
}).required();

var AuthModal = function AuthModal(_ref) {
  var onClose = _ref.onClose,
      phoneNumber = _ref.phoneNumber,
      titleText = _ref.titleText;

  var _useState = (0,react.useState)(null),
      errorMessage = _useState[0],
      setErrorMessage = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isNewCodeAvailable = _useState2[0],
      setIsNewCodeAvailable = _useState2[1];

  var _useState3 = (0,react.useState)(59),
      timer = _useState3[0],
      setTimer = _useState3[1];

  var dispatch = (0,store/* useAppDispatch */.TL)();
  var confirm = (0,store/* useAppSelector */.CG)(selectors/* selectSignIn */.xX);
  var confirmStatus = (0,store/* useAppSelector */.CG)(selectors/* selectConfirmStatus */.jQ);
  var resetConfirmStatus = (0,store/* useAppSelector */.CG)(selectors/* selectResetConfirmStatus */.I0);

  var _useState4 = (0,react.useState)(""),
      code = _useState4[0],
      setCode = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      error = _useState5[0],
      setError = _useState5[1];

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(schema)
  }),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      watch = _useForm.watch;
  /*    const code = watch("code");*/


  (0,react.useEffect)(function () {
    if (confirmStatus === remote/* RemoteDataStatus.Failure */.nX.Failure) {
      setErrorMessage("Неверный код. Попробуйте ещё раз");
    }
  }, [confirmStatus]);
  (0,react.useEffect)(function () {
    if (!!timer) {
      var interval = setInterval(function () {
        return setTimer(timer - 1);
      }, 1000);
      setIsNewCodeAvailable(false);
      return function () {
        return clearInterval(interval);
      };
    } else {
      setIsNewCodeAvailable(true);
    }
  }, [timer]);

  var onSubmit = function onSubmit(data) {
    if (confirm.status === remote/* RemoteDataStatus.Success */.nX.Success) {
      dispatch((0,slice/* confirmUser */.q8)({
        confirmation_id: confirm.data.confirmation_id,
        code: code
      }));
    }
  };

  var newCodeSubmit = function newCodeSubmit() {
    if (confirm.status === remote/* RemoteDataStatus.Success */.nX.Success) {
      dispatch((0,slice/* resetConfirmation */.rS)({
        confirmation_id: confirm.data.confirmation_id
      }));
      setTimer(59);
    }
  };

  var props = {
    inputStyle: {
      MozAppearance: "textfield",
      borderRadius: "10.5px",
      fontSize: "16px",
      height: "44px",
      color: "black",
      width: "44px",
      textAlign: "center",
      border: "1px solid #E4E7EA"
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(modal/* default */.Z, {
    onClose: onClose,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrap, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: titleText
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentWrap, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
          children: "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u043D\u043E\u043C\u0435\u0440 ".concat(phoneNumber)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChangePhoneButton, {
          onClick: onClose,
          children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputLabel, {
          htmlFor: "code",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputTitle, {
            children: "\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmInput, _objectSpread({
            type: "number",
            name: "code",
            inputMode: "numeric",
            value: code,
            onChange: function onChange(e) {
              setCode(e);
              setError(false);
            }
          }, props))]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrors, {
          children: errorMessage
        }), !isNewCodeAvailable && /*#__PURE__*/(0,jsx_runtime.jsx)(GetNewCodeTimer, {
          children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0434 \u043C\u043E\u0436\u043D\u043E \u0447\u0435\u0440\u0435\u0437 00:".concat(timer)
        }), !!+code && /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitCode, {
          type: "submit",
          onClick: onSubmit,
          loading: confirmStatus === remote/* RemoteDataStatus.Pending */.nX.Pending,
          children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C"
        }), isNewCodeAvailable && /*#__PURE__*/(0,jsx_runtime.jsx)(GetNewCode, {
          onClick: newCodeSubmit,
          loading: resetConfirmStatus === remote/* RemoteDataStatus.Pending */.nX.Pending,
          children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0434"
        })]
      })]
    })
  });
};

/* harmony default export */ var authModal = (AuthModal);
;// CONCATENATED MODULE: ./src/images/main-page-desktop.png
/* harmony default export */ var main_page_desktop = ({"src":"/_next/static/media/main-page-desktop.a7dd9d68.png","height":702,"width":1670,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAYElEQVR42mOoq6u76+zs/L+jo+PM4cOHHx0/fvz/1WvX/547f+H/vQcP/zCUlpaqBgQExDEAQWtra317R8f/tvb2/7v37v3/+eu3/wxoQFxNXe0xkH45c9Zsxx+/fjcDAKXRMHhbarriAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/images/main-page-tablet.png
/* harmony default export */ var main_page_tablet = ({"src":"/_next/static/media/main-page-tablet.85b65493.png","height":454,"width":940,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAgUlEQVR42mNobm5+7+Xl9T8tLe3/rl27nh89evT/iZMn/1+7fuP/pStX/zIAFUQGBgZed3Z2ztq9e7fuypUr/2/avOX/7r37/h48fPg/Azrw8PC44O/v99/Z2en/mnXrbjG0trYyR0VFMfn5+bGBFNjZ2XnY2tr+t7C03B8RE8MJAF2KPA+nYQ2cAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/views/authPage/styled.ts




var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-nrl8o1-0"
})(["", ""], function (_ref) {
  var breakpoints = _ref.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["width:100%;max-width:1390px;margin:0 auto;padding:0;overflow:hidden;display:flex;align-items:center;justify-content:center;margin-bottom:80px;@media (max-width:", "){position:relative;}@media (max-width:", "){max-width:100%;padding:0 40px;margin-bottom:40px;}@media (max-width:", "){width:100%;padding:0;}"], breakpoints.smDesktopWidth, breakpoints.maxTableWidth, breakpoints.maxMobileWidth);
});
var BackgroundImageDesktop = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "styled__BackgroundImageDesktop",
  componentId: "sc-nrl8o1-1"
})(["", ""], function (_ref2) {
  var breakpoints = _ref2.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["width:800px;position:absolute;top:0;right:0;@media (max-width:", "){right:-210px;}@media (max-width:", "){display:none;}"], breakpoints.smDesktopWidth, breakpoints.maxTableWidth);
});
var BackgroundImageTablet = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "styled__BackgroundImageTablet",
  componentId: "sc-nrl8o1-2"
})(["", ""], function (_ref3) {
  var breakpoints = _ref3.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["width:470px;position:absolute;top:0;right:0;display:none;@media (max-width:", "){display:block;}@media (max-width:", "){display:none;}"], breakpoints.maxTableWidth, breakpoints.maxMobileWidth);
});
var BackgroundImageMobile = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "styled__BackgroundImageMobile",
  componentId: "sc-nrl8o1-3"
})(["", ""], function (_ref4) {
  var breakpoints = _ref4.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["width:203px;position:absolute;top:0;right:0;display:none;@media (max-width:", "){display:block;}"], breakpoints.maxMobileWidth);
});
var SignWrap = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "styled__SignWrap",
  componentId: "sc-nrl8o1-4"
})(["", ""], function (_ref5) {
  var _ref5$theme = _ref5.theme,
      breakpoints = _ref5$theme.breakpoints,
      colors = _ref5$theme.colors;
  return (0,styled_components_browser_esm/* css */.iv)(["display:flex;flex-direction:column;justify-content:center;align-items:center;gap:16px;margin-top:280px;@media (max-width:", "){margin-top:207px;}@media (max-width:", "){margin-top:150px;border:1px solid ", ";border-radius:10.5px;padding:20px;}"], breakpoints.maxTableWidth, breakpoints.maxMobileWidth, colors.lineGray);
});
var SignTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__SignTitle",
  componentId: "sc-nrl8o1-5"
})(["", ""], function (_ref6) {
  var breakpoints = _ref6.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["font-size:40px;font-weight:400;line-height:1.3;@media (max-width:", "){font-size:32px;}@media (max-width:", "){font-size:18px;}"], breakpoints.maxTableWidth, breakpoints.maxMobileWidth);
});
var BrandsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__BrandsWrap",
  componentId: "sc-nrl8o1-6"
})(["", ""], function (_ref7) {
  var breakpoints = _ref7.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["display:flex;justify-content:center;gap:16px;@media (max-width:", "){display:none;}"], breakpoints.maxMobileWidth);
});
var PhoneInput = (0,styled_components_browser_esm/* default */.ZP)((react_input_mask_default())).withConfig({
  displayName: "styled__PhoneInput",
  componentId: "sc-nrl8o1-7"
})(["", ""], function (_ref8) {
  var _ref8$theme = _ref8.theme,
      colors = _ref8$theme.colors,
      breakpoints = _ref8$theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["border-radius:10.5px;border:1px solid ", ";display:flex;align-items:center;height:44px;width:283px;font-size:13px;padding:0 16px;align-self:center;margin-top:32px;@media (max-width:", "){width:334px;margin-top:0;}"], colors.lineGray, breakpoints.maxMobileWidth);
});
var styled_InputLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__InputLabel",
  componentId: "sc-nrl8o1-8"
})(["", ""], function (_ref9) {
  var breakpoints = _ref9.theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["font-size:13px;display:none;margin-top:8px;@media (max-width:", "){display:flex;}"], breakpoints.maxMobileWidth);
});
var GetSmsBtn = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
  displayName: "styled__GetSmsBtn",
  componentId: "sc-nrl8o1-9"
})(["", ""], function (_ref10) {
  var _ref10$theme = _ref10.theme,
      colors = _ref10$theme.colors,
      breakpoints = _ref10$theme.breakpoints;
  return (0,styled_components_browser_esm/* css */.iv)(["display:flex;align-items:center;align-self:center;justify-content:center;height:44px;border-radius:10.5px;background-color:", ";color:", ";text-transform:uppercase;font-size:13px;padding:0 40px;width:283px;cursor:pointer;&:hover,&:focus{background-color:", " !important;color:", " !important;border:none !important;}@media (max-width:", "){width:334px;}"], colors.black, colors.white, colors.black, colors.white, breakpoints.maxMobileWidth);
});
var styled_FormErrors = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__FormErrors",
  componentId: "sc-nrl8o1-10"
})(["", ""], function (_ref11) {
  var colors = _ref11.theme.colors;
  return (0,styled_components_browser_esm/* css */.iv)(["font-size:11px;color:", ";"], colors.red);
});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/core-functions.ts
var core_functions = __webpack_require__(67211);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 9 modules
var notification = __webpack_require__(57858);
// EXTERNAL MODULE: ./node_modules/antd/dist/antd.css
var antd = __webpack_require__(27083);
;// CONCATENATED MODULE: ./src/components/ui/notification/index.ts


var openErrorNotification = function openErrorNotification() {
  notification/* default.error */.Z.error({
    message: "Что-то пошло не так!",
    description: "Кажется, ошибка с нашей стороны. Попробуйте позднее еще раз или свяжитесь с поддержкой.",
    placement: 'topLeft'
  });
};
;// CONCATENATED MODULE: ./src/views/authPage/index.tsx


function authPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function authPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? authPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : authPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Logo = function Logo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", authPage_objectSpread(authPage_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M35.444 7.306c-.672 0-1.327.576-1.339 1.266-.012.727.636 1.176 1.297 1.176.672 0 1.326-.576 1.338-1.272.013-.727-.636-1.17-1.296-1.17ZM69.013 14.322c-.842-1.636-1.036-3.805-1.206-5.84-.084-.91-.012-1.92-.314-3.12-.14-.521-.316-.964-.655-1.351-.32-.388-.884-.655-1.375-.637-.436 0-.782.14-1.066.297a4.405 4.405 0 0 0-.752.54 4.81 4.81 0 0 0-.75.854c-.183.254-.334.509-.51.781a13.19 13.19 0 0 0-.072-.557c-.134-.83-.328-1.915-.673-2.884-.175-.485-.388-.951-.72-1.381a2.312 2.312 0 0 0-.649-.576 1.923 1.923 0 0 0-.97-.272c-.084 0-.175.006-.26.018C58.375.303 58 .66 57.678 1c-.472.527-.842 1.163-1.181 1.823-.334.66-.618 1.345-.83 1.902-1.376 3.6-1.678 5.865-2.406 8.906-.145.618.23 1.242.836 1.394.612.151 1.23-.23 1.376-.855.757-3.18 1.018-5.222 2.314-8.615.255-.666.636-1.544 1.024-2.217.157-.279.321-.515.454-.678.018.03.037.072.055.109.327.642.593 1.932.739 2.883.018.122.067.534.109.945.048.425.097.855.164 1.194.072.37.145.697.266 1.024.06.163.133.327.279.527a1.313 1.313 0 0 0 .987.551h.06c.383-.012.564-.145.685-.218.212-.157.28-.254.358-.351.242-.315.43-.673.654-1.073.218-.387.443-.8.6-1.036.224-.351.394-.624.527-.817.14-.2.242-.315.388-.443l.127-.109c.006.03.018.06.024.097.2.751.164 1.612.249 2.732.175 2.024.333 4.484 1.448 6.695a1.133 1.133 0 0 0 1.532.503c.564-.285.782-.982.497-1.551ZM52.316 1.92C51.686.963 50.65.151 49.319.018A3.624 3.624 0 0 0 48.96 0c-.642 0-1.23.17-1.757.4-1.835.8-3.102 2.26-3.847 3.956-.75 1.702-1.03 3.641-1.036 5.61 0 1.254.115 2.514.315 3.75.091.563.576.97 1.121.97a1.154 1.154 0 0 0 1.127-1.345 21.239 21.239 0 0 1-.285-3.369c0-.2.006-.4.012-.594.552.11 1.176.212 1.34.237.55.078 1.047.115 1.526.115.315 0 .612-.019.915-.043a6.45 6.45 0 0 0 2.43-.727 6.2 6.2 0 0 0 1.41-1c.788-.775 1.055-1.823 1.055-2.835a5.943 5.943 0 0 0-.97-3.205ZM50.65 6.29a3.963 3.963 0 0 1-.884.617c-.43.23-.97.425-1.57.473a8.214 8.214 0 0 1-1.927-.06c-.071-.013-.453-.073-.835-.14a17.878 17.878 0 0 1-.551-.109 8.84 8.84 0 0 1 .557-1.763c.582-1.29 1.406-2.223 2.672-2.787.315-.14.618-.212.854-.206.043 0 .085 0 .121.006.552.06.982.364 1.351.903.358.533.57 1.278.57 1.908 0 .582-.188 1.006-.358 1.158ZM11.44 6.35c-.12-1.134-.302-2.23-.66-3.23-.357-.987-.914-1.92-1.847-2.526A2.534 2.534 0 0 0 7.539.176C6.77.182 6.122.509 5.583.933c-.806.642-1.448 1.539-2.006 2.532a15.35 15.35 0 0 0-1.296 3.108C1.54 8.627.96 10.85.475 13.02a1.155 1.155 0 0 0 1.115 1.412c.521 0 .988-.364 1.109-.903.388-1.732.836-3.477 1.369-5.113.382.085.757.121 1.12.158.782.066 1.54.072 2.03.151.685.097 1.388.254 2.133.309.079 1.405.14 2.83.351 4.101a1.147 1.147 0 0 0 1.309.958 1.163 1.163 0 0 0 .939-1.333c-.291-1.715-.279-4.15-.51-6.41Zm-3.888.096c-.74-.109-1.503-.109-2.175-.164a5.136 5.136 0 0 1-.564-.066c.333-.854.763-1.715 1.224-2.381.321-.473.66-.848.945-1.072.29-.23.485-.273.557-.273.049.006.08.006.176.06.351.225.666.655.927 1.37.267.727.43 1.702.545 2.787-.466-.061-1.024-.17-1.635-.26ZM28.834 11.456c-.006-.157-.006-.32-.006-.484 0-.764.055-1.624.055-2.472 0-.624-.03-1.242-.152-1.854-.17-.806-.424-1.46-.878-1.975-.449-.521-1.145-.812-1.751-.794-.836.012-1.496.364-2.096.745-.594.394-1.133.867-1.587 1.297l-.14.14c-.006-.2-.006-.407-.006-.613v-.624c0-.605-.006-1.217-.103-1.835-.097-.612-.29-1.26-.751-1.824-.17-.206-.382-.4-.648-.545a1.833 1.833 0 0 0-.873-.224c-.466.006-.842.163-1.15.34-.607.35-1.08.847-1.491 1.423-1.212 1.708-1.993 4.18-2.581 6.391a44.958 44.958 0 0 0-.473 1.97c-.151.744-.284 1.508-.29 2.217a1.15 1.15 0 0 0 1.133 1.163 1.142 1.142 0 0 0 1.145-1.151c0-.412.097-1.085.242-1.751.14-.673.315-1.351.448-1.854.364-1.393.83-2.89 1.375-4.095.273-.6.564-1.127.849-1.527.242-.345.484-.582.672-.709.055.121.11.297.145.54.061.38.073.896.073 1.471v.624c0 .921.012 1.951.303 2.993.055.194.158.442.4.667.236.23.6.351.872.339.328-.006.534-.103.691-.182.273-.151.442-.303.612-.46.248-.237.479-.497.672-.727.194-.224.376-.424.424-.473.4-.381.855-.775 1.267-1.042.405-.279.769-.388.86-.37h.03l.012.013c.043.03.237.278.358.915.073.357.103.842.103 1.387 0 .751-.055 1.605-.055 2.472 0 .188 0 .381.012.575.03.89.067 1.551.182 2.514a1.139 1.139 0 0 0 1.127 1.018c.048 0 .09 0 .14-.006.623-.073 1.066-.648.993-1.284-.103-.903-.127-1.454-.164-2.339Z",
      fill: "#1D1D1D"
    })
  }));
};

Logo.defaultProps = {
  width: "70",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LogoDamixa = function LogoDamixa(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", authPage_objectSpread(authPage_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M64.602 15.687h-4.211l-2.423-3.432-2.494 3.432h-4.14l4.45-5.698-4.37-5.618h4.212l2.342 3.279 2.423-3.279h4.136l-4.372 5.54 4.447 5.776ZM50.242 4.369h-3.668v11.317h3.668V4.37ZM50.322 0h-3.825v2.73h3.825V0ZM37.367 15.687h-3.669V9.99c0-.906.141-2.478-.86-2.888-1.129-.461-2.054.007-2.966.549v8.037h-3.588V4.371h3.588V5.62c1.6-1.402 3.7-2.125 5.698-1.095.559.29 1.014.86 1.327 1.484 1.156-1.027 2.53-1.95 4.14-1.95 1.249 0 2.163.328 2.809 1.093.606.716.94 1.796.94 3.122v7.413h-3.669V9.99c0-1.007.163-2.426-.78-2.888-1.065-.516-2.069-.023-2.97.549v8.037ZM23.082 4.995c-2.164-1.444-6.614-1.335-8.975-.391v2.81c1.186-.579 2.322-.935 3.747-.935 1.015 0 1.718.156 2.264.391.685.342.74.762.78 1.326-1.731.094-4.044.147-5.618.936-1.411.626-2.11 1.737-2.11 3.277 0 1.016.314 1.875 1.095 2.574A3.858 3.858 0 0 0 16.918 16c1.424 0 2.893-.553 3.902-1.562v1.25h3.67V7.961c0-1.327-.471-2.342-1.406-2.967h-.002Zm-2.256 7.725c-.452.454-1.4.784-2.03.784-1.049 0-1.95-.196-1.95-1.405 0-.98.815-1.29 1.632-1.443.753-.142 1.58-.208 2.352-.275l-.004 2.34ZM8.333 0v4.76c-.974-.433-1.76-.7-2.965-.7-3.33 0-5.23 2.995-5.23 6.006 0 1.793.412 3.258 1.25 4.291 1.3 1.612 3.372 2.045 5.228 1.248.546-.233 1.094-.626 1.717-1.09v1.169h3.67V0h-3.67Zm0 12.565c-.958.664-3.01 1.203-3.904-.08-.893-1.283-.8-3.637.158-4.914.798-1.066 2.606-1.005 3.746-.623v5.617Z",
      fill: "#E87017"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M74.498 4.995c-2.164-1.444-6.616-1.335-8.979-.391v2.81c1.185-.58 2.323-.935 3.75-.935 1.012 0 1.717.156 2.264.391.682.342.737.762.78 1.326-1.733.094-4.046.147-5.622.936-1.406.626-2.108 1.737-2.108 3.277 0 1.016.312 1.875 1.096 2.574A3.847 3.847 0 0 0 68.332 16c1.422 0 2.89-.553 3.9-1.562v1.25H75.9V7.961c0-1.327-.47-2.342-1.403-2.967ZM72.23 12.72c-.452.454-1.397.784-2.028.784-1.047 0-1.949-.196-1.949-1.405 0-.98.812-1.29 1.63-1.443.759-.142 1.58-.208 2.351-.275l-.004 2.34ZM79.918 4.371h1.016l.576 1.538.572-1.538h1.017v2.65h-.724V5.284h-.013l-.57 1.737h-.564l-.573-1.737h-.013v1.737h-.72l-.004-2.65Zm-1.768.604h-.715v-.604h2.22v.604h-.708v2.046h-.797V4.975Z",
      fill: "#E87017"
    })]
  }));
};

LogoDamixa.defaultProps = {
  width: "84",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LogoDorff = function LogoDorff(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", authPage_objectSpread(authPage_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.113 1.208a1.123 1.123 0 1 1 2.246 0 1.123 1.123 0 0 1-2.246 0Zm4.881 1.123a1.123 1.123 0 1 0 0-2.246 1.123 1.123 0 0 0 0 2.246Z",
      fill: "#E42313"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M46.212 3.107c0-.579.334-.801.974-.801h.367V.03c-2.131-.266-3.843 1.222-3.843 3.375v12.36h2.4V5.471h1.392V3.105l-1.29.001v.001Zm-5.446 0c0-.579.334-.801.975-.801h.374V.03c-2.137-.266-3.849 1.222-3.849 3.375v12.36h2.4V5.471h1.392V3.105l-1.292.001v.001Zm-11.73 6.382v6.26h2.462V9.767c0-2.677 1.73-4.55 5.116-4.55V2.754c-4.231 0-7.577 2.215-7.577 6.734Z",
      fill: "#000319"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.139 13.66a4.075 4.075 0 1 1 .013-8.151 4.075 4.075 0 0 1-.013 8.15Zm6.367-4.068A6.399 6.399 0 1 0 14.71 9.49a6.399 6.399 0 0 0 12.797.101Z",
      fill: "#E42313"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.865.086v4.046a6.492 6.492 0 0 0-4.185-1.53C3.045 2.606.1 5.606.1 9.305.099 13.003 3.045 16 6.68 16c2.725 0 5.023-1.624 5.97-4.174.487-1.31.614-2.656.614-4.348V.086h-2.4ZM6.645 13.61c-2.328 0-4.216-1.934-4.216-4.313 0-2.38 1.888-4.32 4.216-4.32 2.327 0 4.216 1.934 4.216 4.32s-1.888 4.313-4.216 4.313Z",
      fill: "#000319"
    })]
  }));
};

LogoDorff.defaultProps = {
  width: "48",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};













var phoneRegExp = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/;
var authPage_schema = es/* object */.Ry({
  phone: es/* string */.Z_().matches(phoneRegExp, 'Введите номер телефона').required()
}).required();

var AuthPage = function AuthPage() {
  var _errors$phone;

  var _useState = (0,react.useState)(false),
      isAuthModalOpen = _useState[0],
      setIsAuthModalOpen = _useState[1];

  var _useState2 = (0,react.useState)(''),
      phoneNumber = _useState2[0],
      setPhoneNumber = _useState2[1];

  var dispatch = (0,store/* useAppDispatch */.TL)();
  var confirmStatus = (0,store/* useAppSelector */.CG)(selectors/* selectConfirmStatus */.jQ);
  var confirm = (0,store/* useAppSelector */.CG)(selectors/* selectSignIn */.xX);
  var user = (0,store/* useAppSelector */.CG)(selectors/* selectUser */.dy);
  var router = (0,next_router.useRouter)();

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(authPage_schema)
  }),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      errors = _useForm.formState.errors;

  var submitHandler = function submitHandler(data) {
    dispatch((0,slice/* signIn */.zB)({
      phone: Number(data.phone.slice(1).replace(/\s/g, ""))
    }));
    setPhoneNumber(data.phone);
  };

  (0,react.useEffect)(function () {
    if (confirm.status === remote/* RemoteDataStatus.Success */.nX.Success) {
      setIsAuthModalOpen(true);
    }

    if (confirm.status === remote/* RemoteDataStatus.Failure */.nX.Failure) {
      openErrorNotification();
    }
  }, [confirm]);
  (0,react.useEffect)(function () {
    if (document) {
      if ((0,core_functions/* getCookie */.ej)("access_token")) {
        dispatch((0,slice/* fetchUser */.BT)());
      }
    }
  }, []);
  (0,react.useEffect)(function () {
    if (user.status === remote/* RemoteDataStatus.Success */.nX.Success) {
      if (user.data.is_user_verified) {
        router.push("/myGoods");
      } else {
        router.push("/registration");
      }
    }
  }, [user]);
  (0,react.useEffect)(function () {
    if (confirmStatus === remote/* RemoteDataStatus.Success */.nX.Success && confirm.status === remote/* RemoteDataStatus.Success */.nX.Success) {
      if (confirm.data.is_user_verified) {
        dispatch((0,slice/* setConfirmStatus */.WA)(remote/* RemoteDataStatus.Pending */.nX.Pending));
        router.push("/myGoods");
      } else {
        dispatch((0,slice/* setConfirmStatus */.WA)(remote/* RemoteDataStatus.Pending */.nX.Pending));
        router.push("/registration");
      }
    }
  }, [confirmStatus]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BackgroundImageDesktop, {
        src: main_page_desktop,
        alt: "Фоновое изображение"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackgroundImageTablet, {
        src: main_page_tablet,
        alt: "Фоновое изображение"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackgroundImageMobile, {
        src: main_page_tablet,
        alt: "Фоновое изображение"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SignWrap, {
        onSubmit: handleSubmit(submitHandler),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SignTitle, {
          children: "\u0412\u043E\u0439\u0442\u0438 \u0432 \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BrandsWrap, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoDamixa, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoDorff, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_InputLabel, {
          children: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneInput, authPage_objectSpread({
          type: "phone",
          id: "phone",
          mask: "+7 999 999 99 99",
          placeholder: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430: +7"
        }, register("phone"))), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_FormErrors, {
          children: (_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.message
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(GetSmsBtn, {
          loading: confirm.status == remote/* RemoteDataStatus.Pending */.nX.Pending,
          onClick: handleSubmit(submitHandler),
          type: "submit",
          children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C SMS \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430"
        })]
      })]
    }), isAuthModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(authModal, {
      onClose: function onClose() {
        return setIsAuthModalOpen(false);
      },
      phoneNumber: phoneNumber,
      titleText: "Введите код"
    })]
  });
};

/* harmony default export */ var authPage = (AuthPage);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/index.tsx







var Index = function Index() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 "
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(authPage, {})]
  });
}; // export async function getStaticProps({ locale }) {
//     return {
//         props: {
//             ...(await serverSideTranslations(locale, ["common"])),
//         },
//     };
// }


/* harmony default export */ var pages = (Index);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(27802);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [10,536,939,675,903,629,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);